import React, { useCallback, useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { SIDE_PADDING, TOP_PADDING } from "../../../app/theme/muiTheme";
import Footer from "../../common/Footer";
import VlogCard from "../../common/VlogCard";
import clsx from "clsx";
import api from "../../../app/api";
const usestyles = makeStyles((theme) => ({
  root: {
    paddingTop: TOP_PADDING,
  },
  listroot: {
    minHeight: "65vh",
  },
  whitebg: {
    paddingLeft: SIDE_PADDING,
    paddingBottom: TOP_PADDING,
    [theme.breakpoints.down("md")]: {
      padding: 0,
    },
  },
  greybg: {
    backgroundColor: theme.palette.primary.light,
    paddingLeft: SIDE_PADDING,
    paddingBottom: TOP_PADDING,
    [theme.breakpoints.down("md")]: {
      padding: 0,
    },
  },
}));

const Vlogs = (props) => {
  const classes = usestyles();

  const [vlogList, setVlogsList] = useState([]);

  const fetchVlogs = useCallback(async () => {
    try {
      const { data } = await api.withoutAuth.get("/vlogs");
      setVlogsList(data.message || []);
    } catch (error) {
      console.log(error);
    } finally {
    }
  }, [setVlogsList]);

  useEffect(() => {
    fetchVlogs();
  }, [fetchVlogs]);

  return (
    <div className={classes.root}>
      <div className={classes.listroot}>
        {vlogList.map((vlog, index) => {
          return (
            <div
              key={index}
              className={clsx({
                [classes.whitebg]: index % 2 === 0,
                [classes.greybg]: index % 2 === 1,
              })}
            >
              <VlogCard data={vlog} />
            </div>
          );
        })}
      </div>
      <Footer odd={vlogList.length % 2 === 1} />
    </div>
  );
};

export default Vlogs;
